import {
    SET_SECONDARY_APPROVER
} from './SecondaryApproverType';


const reducers = (state = [], action: any) => {
    switch (action.type) {
        case SET_SECONDARY_APPROVER:
            return {
                ...state,
                secondaryApproverList: action.secondaryApproverList,
            };
        default:
            return state;
    }
}

export {
    reducers
}